import {groupBy, minBy, maxBy} from 'lodash-es'
import moment from 'moment-timezone'

export function calculateLegsForItinerary (itinerary) {
  return Object.values((groupBy(itinerary, 'requestedSegmentRef')) || {})
    .map((sequence) => {
      setupMomentForDates(sequence)
      const firstFlight = minBy(sequence, 'departDate')
      const lastFlight = maxBy(sequence, 'departDate')

      const stops = [...new Set(sequence.flatMap((seq) => [seq.depart, seq.arrive]))]
        .filter((stop) => ![firstFlight.depart, lastFlight.arrive].includes(stop))

      const uniqCabins = [...new Set(sequence.map((seq) => seq.cabin))]

      return {
        flights: sequence,
        firstFlight,
        lastFlight,
        stops,
        isMixedCabin: uniqCabins.length !== 1,
      }
    })
}

function setupMomentForDates (sequence) {
  sequence.forEach((seq) => {
    seq.arriveDate = moment(seq.arriveDate)
    seq.departDate = moment(seq.departDate)
    seq.arriveDateWithTimezone = moment.parseZone(seq.arriveDate)
    seq.departDateWithTimezone = moment.parseZone(seq.departDate)
  })
}

export function calculateLegs (flights = []) {
  return flights.map((flight) => Object.assign({}, flight, {legs: calculateLegsForItinerary(flight.itinerary)}))
}

